// Human-readable plan duration, used everywhere a plan's duration_days is shown
// (admin panel, landing page, wallet, subscribe). null/undefined = never expires.
export function formatDuration(days) {
  if (days === null || days === undefined || days === "") return null;
  const n = parseInt(days, 10);
  if (isNaN(n) || n <= 0) return null;
  if (n % 365 === 0) {
    const years = n / 365;
    return `${years} year${years > 1 ? "s" : ""}`;
  }
  if (n % 30 === 0) {
    const months = n / 30;
    return `${months} month${months > 1 ? "s" : ""}`;
  }
  return `${n} day${n > 1 ? "s" : ""}`;
}

// Human-readable storage size from bytes. Rounds to 1 decimal for TB/GB.
export function formatStorageBytes(bytes) {
  if (bytes === null || bytes === undefined) return null;
  const n = parseInt(bytes, 10);
  if (isNaN(n)) return null;
  if (n >= 1099511627776) return `${(n / 1099511627776).toFixed(n % 1099511627776 === 0 ? 0 : 1)} TB`;
  if (n >= 1073741824) return `${(n / 1073741824).toFixed(1)} GB`;
  if (n >= 1048576) return `${(n / 1048576).toFixed(0)} MB`;
  return `${n} bytes`;
}
